import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../images/ston1.jpg"; // ✅ your logo image

const Navbars = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navigation = [
    { title: "Home", path: "/" },
    { title: "Portfolio", path: "/portfolio" },
    { title: "About Us", path: "/about-us" },
    { title: "Our Expertise", path: "/our-expertise" },
    { title: "Get In Touch", path: "/get-in-touch" },
  ];

  return (
    <nav className="bg-white w-full border-b md:border-0 md:static shadow-sm">
      <div className="flex items-center justify-between px-4 max-w-screen-xl mx-auto md:px-8 py-3">
        {/* Left - Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img
            src={logo}
            width={120}
            height={50}
            alt="Site Logo"
            className="rounded-lg object-cover"
          />
        </Link>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            className="text-gray-700 outline-none p-2 rounded-md focus:border-gray-400 focus:border"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 8h16M4 16h16"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Center - Menu Links */}
        <div
          className={`absolute top-[72px] left-0 w-full bg-white md:static md:w-auto md:block transition-all duration-300 ${
            isOpen ? "block" : "hidden"
          }`}
        >
          <ul className="flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0 md:space-x-8 py-4 md:py-0">
            {navigation.map((item, idx) => (
              <li
                key={idx}
                className="text-gray-700 font-medium hover:text-indigo-600 transition-colors"
              >
                <Link to={item.path} onClick={() => setIsOpen(false)}>
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbars;
